import { Camera } from "lucide-react";

export const Frame = ({ label = "ESPACE PHOTO MSC", ratio = "aspect-[4/3]", dark = false, className = "", src = null, alt = "" }) => (
  <div
    data-testid="photo-frame"
    className={`relative overflow-hidden border ${ratio} ${className} ${
      dark ? "border-white/20 bg-white/[0.04]" : "border-steel/40 bg-midnight/[0.03]"
    }`}
  >
    {src ? (
      <img src={src} alt={alt} loading="lazy" className="absolute inset-0 w-full h-full object-cover" />
    ) : (
      <>
        <div className={`absolute inset-0 ${dark ? "blueprint-dark" : "blueprint"}`} />
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3">
          <Camera className={dark ? "text-white/30" : "text-steel/60"} size={28} strokeWidth={1.5} />
          <span className={`font-mono text-[10px] uppercase tracking-[0.25em] ${dark ? "text-white/40" : "text-steel"}`}>
            {label}
          </span>
        </div>
        <span className={`absolute top-3 left-3 font-mono text-[10px] uppercase tracking-[0.2em] ${dark ? "text-white/40" : "text-steel/80"}`}>
          {label}
        </span>
        <span className={`absolute bottom-3 right-3 font-mono text-[10px] ${dark ? "text-white/25" : "text-steel/60"}`}>
          [ À INTÉGRER ]
        </span>
      </>
    )}
  </div>
);

export default Frame;
